import DateAndTimePicker from "component/ui/Datepicker";
import TabSwitcher from "component/ui/Tabs";
import { FaStar } from "react-icons/fa";
import { useEffect, useState } from "react";
import Input from "component/ui/Input";
import Purchase from "./purchase";
import PageHeading from "component/ui/PageHeading";
import { useDispatch, useSelector } from "react-redux";
import { downloadSaleExcel, getPaymentHistory } from "store/slice/booking";
import { getMaxValue } from "helper/appConstant";
import Button from "component/ui/Button";
import moment from "moment";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";

const PaymentHistory = () => {
  const [booking, setBooking] = useState(1);
  const dispatch = useDispatch();
  const { paymentHistoryData } = useSelector((state) => state.booking);
  const [filterData, setFilterData] = useState({});
  const [loader, setLoader] = useState(false);
  const Booking = [
    {
      id: 1,
      title: "Purchased",
      color: "bg-gradient-to-t from-[#F178B0] to-[#DB0C6E]",
      icon: <FaStar color="orange" size={25} />,
      border: booking == 1,
      onClick: () => {
        setFilterData({});
        setBooking(1);
        fetchPaymentHistory(null, null, null, null, 1);
      },
    },
    {
      id: 2,
      title: "Sold",
      color: "bg-gradient-to-t from-[#B2BBFF] to-[#2BACE2]",
      icon: <FaStar color="orange" size={25} />,
      border: booking == 2,
      onClick: () => {
        setFilterData({});
        setBooking(2);
        fetchPaymentHistory(null, null, null, null, 2);
      },
    },
  ];
  useEffect(() => {
    fetchPaymentHistory();
  }, []);

  const fetchPaymentHistory = (page, startDate, endDate, search, type) => {
    setLoader(true);
    const request = {
      language: "en",
      type: type ?? booking,
      page: page ?? 1,
      perPage: 12,
      startDate: startDate
        ? startDate == "N/A"
          ? ""
          : startDate
        : filterData?.startDate ?? "",
      endDate: endDate
        ? endDate == "N/A"
          ? ""
          : endDate
        : filterData?.endDate ?? "",
      buyerName:
        search && booking == 2 ? search ?? filterData?.search ?? null : null,
      sellerName:
        search && booking == 1 ? search ?? filterData?.search ?? null : null,
      listType: [1],
    };
    dispatch(getPaymentHistory(request, setLoader));
  };

  const handleDownload = () => {
    const request = {
      language: "en",
      type: booking,
      startDate: filterData?.startDate ?? "",
      endDate: filterData?.endDate ?? "",
      listType: [1],
    };
    dispatch(downloadSaleExcel(request));
  };
  return (
    <div className="min-h-screen bg-gray-100 md:p-5 p-3">
      <div className="container mx-auto">
        <PageHeading title={"Payment History"} />

        <div className="bg-white min-h-screen rounded-md mt-5">
          <TabSwitcher tabs={Booking} />
          {loader ? (
            <div className="h-[20vh] flex justify-center items-center w-full">
              {" "}
              <div className="h-10 w-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : (
            <div className="pt-4 border-t border-gray-200 md:px-6 px-3">
              {/* <div className="mb-8"> */}
              <h1 className="text-2xl font-semibold text-gray-800 mb-3">
                {booking == 1 ? "Purchased" : "Sold History"}
              </h1>
              {/* </div> */}

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                <DateAndTimePicker
                  showDate
                  selectedDate={filterData?.startDate}
                  showTime={false}
                  onDateChange={(date) => {
                    setFilterData((filterData) => ({
                      ...filterData,
                      startDate: date
                        ? moment(date).format("YYYY-MM-DD") + "T00:00:00Z"
                        : "",
                    }));
                    fetchPaymentHistory(
                      null,
                      date
                        ? moment(date).format("YYYY-MM-DD") + "T00:00:00Z"
                        : "N/A"
                    );
                  }}
                  dateLabel="Start Date"
                  placeholder="Enter start date"
                  isRequired
                  inputClassName="w-full"
                />

                <DateAndTimePicker
                  showDate
                  selectedDate={filterData?.endDate}
                  showTime={false}
                  onDateChange={(date) => {
                    setFilterData((filterData) => ({
                      ...filterData,
                      endDate: date
                        ? moment(date).format("YYYY-MM-DD") + "T00:00:00Z"
                        : "",
                    }));
                    fetchPaymentHistory(
                      null,
                      null,
                      date
                        ? moment(date).format("YYYY-MM-DD") + "T00:00:00Z"
                        : "N/A"
                    );
                  }}
                  dateLabel="End Date"
                  placeholder="Enter end date"
                  isRequired
                  inputClassName="w-full"
                />

                <div className="flex items-center w-full">
                  <Input
                    label="Search"
                    className="w-full"
                    value={filterData?.search}
                    onChange={(val) => {
                      setFilterData((filterData) => ({
                        ...filterData,
                        search: val,
                      }));
                      fetchPaymentHistory(null, null, null, val);
                    }}
                    placeholder={
                      booking == 1
                        ? "Search by seller name"
                        : "Search by buyer name"
                    }
                  />
                  <PiMicrosoftExcelLogoFill
                    onClick={handleDownload}
                    className="text-highlight h-10 w-10 mt-4 pt-2 cursor-pointer"
                  />
                </div>
              </div>

              <Purchase bookingType={booking} data={paymentHistoryData} />
              {/* view more button */}
              {paymentHistoryData?.total > paymentHistoryData?.data?.length && (
                <div className="flex justify-center py-3">
                  <Button
                    children={"View More"}
                    onClick={() => {
                      fetchPaymentHistory(
                        getMaxValue(paymentHistoryData?.data?.length, 12) + 1
                      );
                    }}
                  />
                </div>
              )}
            </div>
          )}
          {/* {booking === 2 && (
            <div className="md:px-6 px-3 py-4">
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                Sold History
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                <DateAndTimePicker
                  showDate
                  showTime={false}
                  dateLabel="Start Date"
                  placeholder="Enter start date"
                  isRequired
                  inputClassName="w-full"
                />

                <DateAndTimePicker
                  showDate
                  showTime={false}
                  dateLabel="End Date"
                  placeholder="Enter end date"
                  isRequired
                  inputClassName="w-full"
                />

                <div className="w-full">
                  <Input label="Search History" placeholder="Search Sport" />
                </div>
              </div>
              <Sold />
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default PaymentHistory;
